import { render } from "./payout.vue?vue&type=template&id=42928531"
import script from "./payout.vue?vue&type=script&lang=js"
export * from "./payout.vue?vue&type=script&lang=js"

import "./payout.vue?vue&type=style&index=0&id=42928531&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__